((Drupal) => {
  "use strict";

  // Makes rows in the "My Assignments" table clickable,
  // redirecting users to the assignment's linked page.
  const assignmentsTableLinked = (context) => {
    const assignmentsTable = context.querySelector(
      ".view-my-assignments-teacher.view-display-id-default"
    );

    if (!assignmentsTable) return;

    assignmentsTable.addEventListener("click", (e) => {
      const row = e.target.closest(".table-row-separated");
      if (!row) return;

      const link = row.querySelector(".view-assignment-name a");
      if (link) {
        window.location.href = link.href;
      }
    });
  };

  Drupal.behaviors.assignmentsTableLinked = {
    attach(context) {
      assignmentsTableLinked(context);
    },
  };
})(Drupal);
